/* eslint-disable */
import { useContext } from "react";

import { PolicyCard } from "../../components/policy/PolicyCard";
import { LocalizationContext } from "../../App";
import { PolicyStatus } from "../../models/enum/PolicyStatus";
import { Insurance } from "../../common/icons";
import { useGetPoliciesWithStatusDefinitionsQuery } from "../../hooks/useGetPoliciesWithStatusDefinitionsQuery";

export const PolicyList = () => {
  const l10n = useContext(LocalizationContext);
  const { data: policies, isLoading } = useGetPoliciesWithStatusDefinitionsQuery();

  if (isLoading)
    return (
      <div className="loading-screen flex flex-col justify-center items-center">
        <div className="text-body text-xl">{l10n.common.loading}</div>
      </div>
    );

    const activePolicies = policies?.filter(({ statusId, subStatusId }) =>
        (statusId === PolicyStatus.Policy) ||
        (statusId === PolicyStatus.Offer && [2, 23].includes(subStatusId))
    );

  return (
      <>
       <h2>{activePolicies?.length > 1 ? l10n.title.yourActivePolicies : l10n.title.yourActivePolicy}</h2>

      {activePolicies?.length ? (
        activePolicies.map((policy, index) => <PolicyCard key={index} policy={policy} />)
      ) : (
        <div className="no-data-screen flex flex-col justify-center items-center text-center text-body px-4">
          <Insurance className="w-32 h-32 stroke-1.5 stroke-no-data" />
          <div className="mt-4 text-body">{l10n.noData.activePolicies}</div>
        </div>
      )}
    </>
  );
};
